module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Home-df4a8e2cf6082360eb9f3b1a70913f6a.svg";